import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import BootstrapVue from 'bootstrap-vue';
import './main.scss'

Vue.use(BootstrapVue)

Vue.config.productionTip = false
Vue.use(BootstrapVue)

router.beforeEach( (to, from, next) => {
  if ( to.name === 'home' ) {
    if ( to.path === '/logout' ) {
      store.dispatch( 'logout' );
    }
    next();
  }
  else {
    store.dispatch( 'verifyAuthentification' )
      .then( () => next() )
      .catch( () => next({name: 'home', query: { redirect: to.path }}) )
  }

});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
